<template>
  <Modal v-model="cancelPlatformOrderModal" :title="$t('key1004290')" width="800" :transfer="false" :mask-closable="false"
    class-name="cancelOrderModalStyle" @on-visible-change="cancelOrderModalChange">
    <Alert style="width: 630px; margin: 0 0 20px 119px;" type="warning" show-icon v-if="!noPlatformReasonsList.includes(platformId) && optionsType === 'platformOrder'">
      {{ $t('key1006077') }}
    </Alert>
    <Form ref="cancelOrderForm" :model="cancelOrderForm" :rules="ruleValidate" :label-width="120" @submit.native.prevent>
      <Row style="width: 98%;">
        <!--        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item label="取消类型：" prop="invalidType" @on-change="invalidTypeChange">
                    <Select v-model="cancelOrderForm.invalidType" transfer :disabled="invalidTypeTalg">
                      <Option v-for="(item, index) in cancelTypeList" :value="item.value" :key="index">{{ item.name }}</Option>
                    </Select>
                  </Form-item>
                </Col>-->
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1006075')" prop="cancelRange">
            <Select v-model="cancelOrderForm.cancelRange" transfer @on-change="selectChange" :disabled="cancelRangeTalg">
              <Option v-for="(item, index) in cancelRangeList" :value="item.value" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="`${configCharacters()}` + $t('key1001071')" prop="invalidReason">
            <Input v-model.trim="cancelOrderForm.invalidReason"
              :placeholder="$t('key1004287') + `${configCharacters()}` + $t('key1006028') + `${configCharacters()}` + $t('key1006029')"
              type="textarea" :rows="5">
            </Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol"
          v-if="!noPlatformReasonsList.includes(platformId) && cancelOrderForm.invalidType === 1">
          <Form-item :label="$t('key1001071')" prop="platformInvalidReason">
            <Select v-model="cancelOrderForm.platformInvalidReason" transfer :placeholder="$t('key1006076')">
              <Option v-for="(item, index) in cancelReasonList" :value="item.value" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="cancelOrderForm.cancelRange === 1">
          <Form-item :label="$t('key1006030')" class="required_style_label reset_item_content">
            <div class="table_box">
              <!--需要展示平台交易号，按照平台交易号维度展示的列表-->
              <Table
                v-if="platformIdList.includes(platformId)"
                highlight-row
                border
                max-height="520"
                :span-method="handleSpan"
                :loading="tableLoading"
                @on-selection-change="tableChange"
                :columns="platformColumns"
                :data="platformTableData">
              </Table>
              <Table
                v-else
                highlight-row
                border
                max-height="520"
                :loading="tableLoading"
                :columns="tableColumns"
                :data="tableData">
              </Table>
            </div>
          </Form-item>
        </Col>
        <p v-if="invalidhandlerTalg" class="redColor flex align-items-center font-size-13 ml120">
          <span>{{ $t('key1006078') }}</span>
          <span>{{ invalidhandlerCost + invalidhandlerCostCurrency }}</span>
          <span>{{ $t('key1001215') }}</span>
        </p>
      </Row>
    </Form>
    <template #footer>
      <div style="text-align: right;">
        <Button @click="cancelPlatformOrderModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="reasonCancellationEbayBtn">{{ $t('key1000111') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {setConfigCharacters} from "@/utils/common";

export default {
  name: 'cancelPlatformOrderModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      cancelPlatformOrderModal: false,
      ymsPlatformOrderId: '',
      cancelOrderForm: {
        invalidType: null, // 取消类型 0取消YMS订单、1取消平台订单
        cancelRange: null, // 取消范围
        invalidReason: '', // YMS取消原因
        platformInvalidReason: '', // eBay取消原因
      },
      ruleValidate: {
        /*  invalidType: [
            {required: true, message: '请选择取消类型', trigger: 'change', type: 'number'}
          ],*/
        cancelRange: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006047'), trigger: 'change', type: 'number'}
        ],
        invalidReason: [
          {required: true, message: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004287')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004288')}`, trigger: 'blur'}
        ],
        platformInvalidReason: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006048'), trigger: 'change'}
        ]
      },
      platformId: null,
      cancelTypeList: [
        /* {value: 0, name: `取消${setConfigCharacters()}订单`},*/
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006049')}
      ],
      cancelRangeList: [
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006023')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006024')}
      ],
      cancelReasonList: [],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'pictureUrl'),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.title),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.ymsSku),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'quantity',
          align: 'center',
          width: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004317'),
          key: 'cancelQuantity',
          align: 'center',
          width: 130,
          render: (h, params) => {
            let quantity = params.row.quantity;
            return h('div', [
              h('InputNumber', {
                props: {
                  value: null,
                  min: 1,
                  max: quantity,
                  formatter: value => `${parseInt(value)}`
                },
                style: {
                  width: '90px',
                  textAlign: 'left'
                },
                on: {
                  'on-change': num => {
                    v.$set(v.tableData[params.index], 'cancelQuantity', parseInt(num));
                  }
                }
              })
            ]);
          }
        },
      ],
      tableData: [],
      platformColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006050'),
          key: 'platformOrderTransactionId',
          align: 'left',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 280,
          render(h, params) {
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'pictureUrl'),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.title),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.ymsSku),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'quantity',
          align: 'left',
          width: 110
        }
      ],
      platformTableData: [],
      platformIdList: ['ebay', 'shopee', 'walmart'], // 当订单为shopee、ebay、walmart时，需展示对应交易号
      selectTableData: [],
      ymsPackageInfoTalg: false,// 标记是否生成YMS订单
      noPlatformReasonsList: ['amazon', 'aliexpress', 'fruugo', 'alibaba'], // 没有取消平台原因的平台
      platformOrderStatus: null,
      invalidhandlerCost: 0,
      invalidhandlerCostCurrency: null,
      invalidhandlerTalg: false,
      optionsType: null,
    };
  },
  computed: {
    // 取消类型禁用的判断
    invalidTypeTalg() {
      let talg = false;
      // 还没有对接取消平台订单原因
      if (['amazon', 'alibaba', 'temu_choice'].includes(this.platformId)) {
        talg = true;
      }
      /**
       * wish平台订单
       * 平台订单状态=1，待发货时，原因如下：
       * "UNABLE_TO_SHIP"，翻译：无法送达
       * 平台订单状态=2，已发货时，原因如下：
       * "ITEM_IS_DAMAGED"，翻译：物品已损坏
       * "ITEM_RETURNED_TO_SENDER"，翻译：物品退回发件人
       * 其他状态时仅只支持取消YMS订单，需控制
       */
      else if (this.platformId === 'wish') {
        if (!['1', '2'].includes(this.platformOrderStatus)) {
          talg = true;
        } else {
          if (!this.ymsPackageInfoTalg) {
            talg = true;
          }
        }
      }
      // 其他平台没有生成YMS订单
      else {
        if (!this.ymsPackageInfoTalg) {
          talg = true;
        }
      }
      return talg;
    },
    // 取消范围禁用的判断
    cancelRangeTalg() {
      let talg = false;
      // 只有ebay、shopee平台订单支持取消部分商品，其他平台只支持整单取消
      if (!['ebay', 'shopee'].includes(this.platformId)) {
        talg = true;
      }
      if (this.platformId === 'wish') {
        if (['1', '2'].includes(this.platformOrderStatus)) {
          talg = true;
        }
      } else {
        if (this.cancelOrderForm.invalidType === 1 && !this.ymsPackageInfoTalg) {
          talg = true;
        }
      }
      if (this.cancelOrderForm.invalidType === 0) {
        talg = false;
      }
      return talg;
    }
  },
  methods: {
    // 初始化数据
    initCancelOrderData(platformOrderDetails, ymsPlatformOrderId, ymsPackageInfoTalg, optionsType) {
      let v = this;
      console.log('======是否生成YMS订单：=======', ymsPackageInfoTalg);
      v.optionsType = optionsType;
      v.cancelOrderForm.invalidType = optionsType === 'platformOrder' ? 1 : 0;
      v.invalidhandlerTalg = false;
      v.invalidhandlerCost = 0;
      v.invalidhandlerCostCurrency = null;
      v.ymsPackageInfoTalg = ymsPackageInfoTalg;
      v.ymsPlatformOrderId = ymsPlatformOrderId;
      v.platformId = platformOrderDetails.platformId;
      v.platformOrderStatus = platformOrderDetails.platformOrderStatus; // 三方平台订单状态 0:核查中、1:待发货、2:已发货、21:部分发货、3:已签收、31:部分签收、4:取消、41:部分取消
      v.tableData = [];
      v.platformTableData = [];
      let newList = [];
      // 获取当前平台订单下所有YMS订单的订单取消处理费用
      let ymsPlatformOrderPackageRelateds = platformOrderDetails.ymsPlatformOrderPackageRelateds || [];
      let list = ymsPlatformOrderPackageRelateds.filter((ele) => {
        return ele.ymsPackageInfo && ele.ymsPackageInfo.status === 6 && ele.ymsPackageInfo.allowInvalid === 1;
      });
      if (list.length > 0) {
        v.invalidhandlerTalg = true;
        v.invalidhandlerCostCurrency = list[0].ymsPackageInfo.invalidHandlerCostCurrency;
        v.invalidhandlerCost = list.reduce((acc, ele) => acc + ele.ymsPackageInfo.invalidHandlerCost, 0);
      }
      // 获取需要取消的商品数据
      let ymsPlatformOrderShippingDetails = platformOrderDetails.ymsPlatformOrderShippingDetails || [];
      let businessIds = [];
      if (ymsPlatformOrderShippingDetails.length > 0) {
        ymsPlatformOrderShippingDetails.map((item) => {
          if (item.businessId) {
            item.ymsProductGoodsId = item.businessId;
            businessIds.push(item.businessId);
          }
        });
        if (businessIds.length > 0) {
          (async () => {
            newList = await v.getProductInfoByIds(businessIds, ymsPlatformOrderShippingDetails);
            if (newList.length > 0) {
              newList.map((item) => {
                if (item._productInfo) {
                  item.title = item._productInfo._spuInfo.name;
                  item.ymsSku = item._productInfo.ymsSku;
                  let skuImgPath = item._productInfo.primaryImage;
                  let spuImgPath = item._productInfo._spuInfo.primaryImage;
                  item.pictureUrl = skuImgPath ? skuImgPath : spuImgPath;
                  // let productGoodsSpecificationList = item._productInfo.productGoodsSpecificationList || [];
                  // item.specifications = productGoodsSpecificationList.map(i => i.name + '：' + i.value).join('、');
                }
              });
              let list = [];
              // 当订单为shopee、ebay、walmart时，需展示对应交易号
              if (v.platformIdList.includes(v.platformId)) {
                let newData = v.handerGrouping(newList, function (item) {
                  return [item.platformOrderTransactionId];
                }, 'platformOrderTransactionId');
                newData.map((item) => {
                  if (item.data.length > 0) {
                    item.data.map((ele, index) => {
                      let length = item.data.length;
                      ele['length'] = length;
                      ele['currentTalg'] = (length > 1 && index === 0);
                      list.push(ele);
                    });
                  }
                });
                if (list.length > 0) {
                  list.map((item, idx) => {
                    item['tableLength'] = list.length;
                    if (item.currentTalg) {
                      item['currentIndex'] = idx;
                    }
                  });
                  v.platformTableData = list;
                }
              } else {
                newList.map((item) => {
                  item.cancelQuantity = 0;
                });
                this.tableData = newList;
              }
            }
          })();
        }
      }
      v.cancelPlatformOrderModal = true;
    },
    // 监听弹窗
    cancelOrderModalChange(value) {
      let v = this;
      if (value) {
        if (['amazon', 'alibaba', 'temu_choice'].includes(v.platformId)) {
        } else if (v.platformId === 'wish') {
          if (['1', '2'].includes(v.platformOrderStatus)) {
            v.cancelOrderForm.cancelRange = 0;
            v.selectChange(0);
          }
        } else {
          if (!v.ymsPackageInfoTalg) {
            v.cancelOrderForm.cancelRange = 0;
            v.selectChange(0);
          } else {
            v.selectChange(0);
          }
        }
        if (v.ymsPackageInfoTalg) {
          v.cancelOrderForm.cancelRange = 0;
          v.selectChange(0);
        }
      } else {
        v.tableData = [];
        v.cancelReasonList = [];
        v.selectTableData = [];
        v.optionsType = null;
        v.$nextTick(() => {
          v.$refs['cancelOrderForm'].resetFields();
        });
      }
    },

    // 取消订单的确定按钮
    reasonCancellationEbayBtn() {
      let invalidPlatformOrderSkus = [];
      // 部分取消
      if (this.cancelOrderForm.cancelRange === 1) {
        if (this.platformIdList.includes(this.platformId)) {
          if (this.platformTableData.length > 0) {
            if (this.selectTableData.length > 0) {
              let newList = this.platformTableData.map((item) => {
                return item.platformOrderTransactionId;
              });
              newList = this.uniqueFunc(newList);
              if (this.selectTableData.length !== newList.length) {
                this.platformTableData.map((item) => {
                  let quantity = item.quantity;
                  this.selectTableData.map((ele) => {
                    if (item.platformOrderTransactionId === ele.platformOrderTransactionId) {
                      quantity = 0;
                    }
                  });
                  invalidPlatformOrderSkus.push({
                    quantity: quantity,
                    sku: item.ymsSku,
                    platformOrderTransactionId: item.platformOrderTransactionId
                  });
                });
              } else {
                this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006051'));
                return false;
              }
            } else {
              this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006052'));
              return false;
            }
          } else {
            this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006053'));
            return false;
          }
        } else {
          if (this.tableData.length > 0) {
            let allTalg = this.tableData.every((item) => {
              return !item.cancelQuantity;
            });
            if (allTalg) {
              this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006025'));
              return false;
            }
            // 取消数量总数
            let cancelQuantityTotal = this.tableData.reduce((pre, cur) => {
              return pre + cur.cancelQuantity;
            }, 0);
            // 订单数量总数
            let quantityTotal = this.tableData.reduce((pre, cur) => {
              return pre + cur.quantity;
            }, 0);
            if (cancelQuantityTotal >= quantityTotal) {
              this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006026'));
              return false;
            }
            this.tableData.map((item) => {
              let cancelQuantity = item.cancelQuantity || 0;
              invalidPlatformOrderSkus.push({
                quantity: item.quantity - cancelQuantity,
                sku: item.ymsSku,
                platformOrderTransactionId: item.platformOrderTransactionId
              });
            });
          } else {
            this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006053'));
            return false;
          }
        }
      }
      // 整单取消 （ebay平台订单中在没有创建YMS订单时，进行取消订单--整单取消时，是允许取消的）
      else {
        invalidPlatformOrderSkus = [];
      }
      this.$refs['cancelOrderForm'].validate((valid) => {
        if (valid) {
          let query = {
            invalidPlatformOrderSkusBos: invalidPlatformOrderSkus,
            ymsPlatformOrderId: this.ymsPlatformOrderId,
            invalidType: this.cancelOrderForm.invalidType,
            invalidReason: this.cancelOrderForm.invalidReason,
            platformInvalidReason: this.cancelOrderForm.platformInvalidReason,
          };
          this.axios.put(api.put_ymsPlatformOrder_invalid, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              if (data) {
                this.$Message.error(data);
                return false;
              } else {
                this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001067'));
                this.cancelPlatformOrderModal = false;
                this.$emit('updateData');
              }
            }
          });
        }
      });
    },
    // 选择取消类型
    invalidTypeChange() {
      this.cancelOrderForm.platformInvalidReason = '';
    },

    // 选择取消范围
    selectChange(value) {
      this.cancelOrderForm.platformInvalidReason = '';
      this.cancelReasonList = [];
      let wholeOrderCancelList = []; // 整单取消
      let partialCancelList = []; // 部分取消
      switch (this.platformId) {
        case 'ebay':
          wholeOrderCancelList = [
            {value: 'ADDRESS_ISSUES', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006054')},
            {value: 'BUYER_ASKED_CANCEL', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006055')},
            {value: 'ORDER_UNPAID', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006056')},
            {value: 'OUT_OF_STOCK_OR_CANNOT_FULFILL', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006057')},
          ];
          partialCancelList = [
            {value: 'BuyerNoLongerWantsItem', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006058')},
            {value: 'BuyerPurchasingMistake', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006059')},
            {value: 'UnableToResolveTerms', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006060')},
            {value: 'SellerRanOutOfStock', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006061')},
          ];
          this.cancelReasonList = value ? partialCancelList : wholeOrderCancelList;
          break;
        case 'ozon':
          wholeOrderCancelList = [
            {value: 352, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000536')},
            {value: 400, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006062')},
            {value: 401, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006063')},
            {value: 402, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006064')},
            {value: 665, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006065')},
            {value: 666, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006066')},
            {value: 667, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006067')}
          ];
          this.cancelReasonList = wholeOrderCancelList;
          break;
        case 'shopee': // 整单取消和部分取消的原因一样
          wholeOrderCancelList = [
            {value: 'OUT_OF_STOCK', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000536')}
          ];
          this.cancelReasonList = wholeOrderCancelList;
          break;
        case 'walmart':
          wholeOrderCancelList = [
            {value: 'CUSTOMER_REQUESTED_SELLER_TO_CANCEL', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006068')},
            {value: 'SELLER_CANCEL_PRICING_ERROR', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006069')},
            {value: 'SELLER_CANCEL_OUT_OF_STOCK', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000536')},
            {value: 'SELLER_CANCEL_FRAUD_STOP_SHIPMENT', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006070')},
            {value: 'SELLER_CANCEL_ADDRESS_NOT_SERVICEABLE', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006071')},
          ];
          this.cancelReasonList = wholeOrderCancelList;
          break;
        case 'wish':
          if (this.platformOrderStatus === '1') {
            wholeOrderCancelList = [
              {value: 'UNABLE_TO_SHIP', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006072')}
            ];
          } else if (this.platformOrderStatus === '2') {
            wholeOrderCancelList = [
              {value: 'ITEM_IS_DAMAGED', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006073')},
              {value: 'ITEM_RETURNED_TO_SENDER', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006074')}
            ];
          } else {
            wholeOrderCancelList = [];
          }
          this.cancelReasonList = wholeOrderCancelList;
          break;
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let columnList = [0, 1];
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    }
  }
};
</script>

<style lang="less" scoped>
.cancelOrderModalStyle {
  /deep/ .ivu-form-item-content {
    line-height: inherit !important;
  }

  .reset_item_content /deep/ .ivu-form-item-content {
    line-height: initial !important;
  }
}
</style>